import React from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';

export const AdminSortableItem = ({
    item,
    inventoryManageData,
    updateInventoryManage,
    priceFormatter,
    getImages
}) => {
    // Setup dnd-kit hooks
    const {
        attributes,
        listeners,
        setNodeRef,
        transform,
        transition,
        isDragging
    } = useSortable({ id: item.vin });

    // Styles for the movement animation
    const style = {
        transform: CSS.Transform.toString(transform),
        transition,
        opacity: isDragging ? 0.5 : 1,
        position: 'relative',
        zIndex: isDragging ? 999 : 'auto',
    };

    const isSelected =
        inventoryManageData[item.vin]?.home ||
            inventoryManageData[item.vin]?.srp
            ? "selected"
            : "";

    return (
        <table className={`w-100 custom-table mb-2px ${isSelected}`}
            ref={setNodeRef}
            style={style}
            {...attributes}>
            <tbody>
                <tr
                >
                    <td style={{ width: '30%' }} className='text-start'>
                        <div className='xs-title fw-700'>{item.vehicle_name}</div>
                    </td>

                    <td style={{ width: '5%' }} className='text-center'>
                        {item.vin.slice(-4)}
                    </td>
                    
                    <td style={{ width: '5%' }} className='text-center'>
                        {item.location.slice(-2)}
                    </td>

                    <td style={{ width: '13%' }} className='text-center'>
                        {priceFormatter(item.price, true)}
                    </td>

                    {/* <td style={{ width: '10%' }} className='text-center'>
                        {item.stockno}
                    </td> */}

                    {/* HOME CHECKBOX */}
                    <td style={{ width: '10%' }} className='text-center'>
                        <div className="custom-checkbox dash-checkbox mx-auto">
                            <input
                                type="checkbox"
                                id={`chk_home_${item.vin}`}
                                checked={inventoryManageData[item.vin]?.home || false}
                                onChange={(e) => updateInventoryManage(e, item.vin, "home")}
                            />
                            <label htmlFor={`chk_home_${item.vin}`} className="w-100"></label>
                        </div>
                    </td>

                    {/* SRP CHECKBOX */}
                    <td style={{ width: '10%' }} className='text-center'>
                        <div className="custom-checkbox dash-checkbox mx-auto">
                            <input
                                type="checkbox"
                                id={`chk_srp_${item.vin}`}
                                checked={inventoryManageData[item.vin]?.srp || false}
                                onChange={(e) => updateInventoryManage(e, item.vin, "srp")}
                            />
                            <label htmlFor={`chk_srp_${item.vin}`} className="w-100"></label>
                        </div>
                    </td>

                    {/* HIDE SWITCH */}
                    <td style={{ width: '10%' }} className='text-center'>
                        <label className="switch custom-switch">
                            <input
                                type="checkbox"
                                id={`chk_hide_${item.vin}`}
                                checked={inventoryManageData[item.vin]?.hide || false}
                                onChange={(e) => updateInventoryManage(e, item.vin, "hide")}
                            />
                            <span className="slider round"></span>
                        </label>
                    </td>
                    <td style={{ width: '10%' }} className='text-center'>
                        <label className="switch custom-switch">
                            <input
                                type="checkbox"
                                id={`chk_pending_${item.vin}`}
                                checked={inventoryManageData[item.vin]?.pending || false}
                                onChange={(e) => updateInventoryManage(e, item.vin, "pending")}
                            />
                            <span className="slider round"></span>
                        </label>
                    </td>
                    {/* DRAG HANDLE (MENU BUTTON) */}
                    <td style={{ width: '7%' }} className='text-end'>
                        <button
                            type="button"
                            className="btn-menu-icon"
                            style={{ cursor: 'grab' }}
                            // Apply listeners HERE so only the icon initiates drag
                            {...listeners}
                        >
                            <img src={getImages('menu-icon.png')} alt="Drag Handle" />
                        </button>
                    </td>
                </tr>
            </tbody>
        </table>
    );
};